<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop size="lg">
            <fuel-storage-create-or-update
                v-model="form"
                :errors="errors"
                :branches="branches"
                :provinces="provinces"
                :fuelTypes="fuelTypes"
                :integratedStorageClasses="integratedStorageClasses"
                :storageClasses="storageClasses"
                :fuelStorageTypes="fuelStorageTypes"
                :fuelStorageMaterials="fuelStorageMaterials"
                :fuelStorageMobilityStatuses="fuelStorageMobilityStatuses"
            />
            <template #modal-footer>
                <v-executer :loading="loading" :editing="editing" :action="createOrUpdate" :disabled="isSaveDisabled"></v-executer>
            </template>
        </b-modal>

        <b-modal id="manage-employees" title="Çalışanları Yönet" no-close-on-esc no-close-on-backdrop size="lg" v-on:hidden="selectedFuelStorageId = null">
            <div v-if="employeeManagementLoading" class="d-flex justify-content-center align-items-center" style="height: 200px">
                <b-spinner variant="primary" label="Yükleniyor..."></b-spinner>
            </div>
            <fuel-storage-employee-create-or-update v-else v-model="employeeManagementModel" :all-users="activeUsers" :has-overlap-error="hasEmployeeOverlap" />
            <template #modal-footer> <v-executer :loading="employeeManagementLoading" text="Kaydet" :action="manageEmployees" :disabled="isEmployeeManagementSaveDisabled"></v-executer> </template>
        </b-modal>

        <b-modal id="stock-balance" title="Stok Dengeleme" no-close-on-esc no-close-on-backdrop size="md">
            <fuel-storage-stock-balance v-model="balanceModal" :fuel-storage="selectedFuelStorage" :errors="errors" />
            <template #modal-footer>
                <v-executer :loading="loading" text="Dengele ve Kaydet" :action="saveBalance"></v-executer>
            </template>
        </b-modal>

        <b-modal id="pump-management" :title="pumpModal.title" size="lg" no-close-on-esc no-close-on-backdrop>
            <div class="mb-2">
                <h6>Pompa Ekle</h6>
                <b-row>
                    <b-col md="4">
                        <b-form-input v-model="pumpForm.Name" placeholder="Pompa Adı" size="sm" />
                    </b-col>
                    <b-col md="4">
                        <b-form-select v-model="pumpForm.MeterType" :options="meterTypes" size="sm" />
                    </b-col>
                    <b-col md="4">
                        <b-button variant="success" size="sm" @click="addPump" :disabled="!pumpForm.Name">Ekle</b-button>
                    </b-col>
                </b-row>
            </div>
            <hr />
            <div v-if="pumpLoading" class="text-center py-2"><b-spinner variant="primary" small /></div>
            <table v-else class="table table-bordered table-sm">
                <thead class="thead-light">
                    <tr>
                        <th>Pompa Adı</th>
                        <th>Sayaç Tipi</th>
                        <th>Durum</th>
                        <th style="width:120px">İşlem</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="pump in pumps" :key="pump.Id">
                        <td>{{ pump.Name }}</td>
                        <td>{{ pump.MeterType }}</td>
                        <td><b-badge :variant="pump.IsActive ? 'success' : 'secondary'">{{ pump.IsActive ? 'Aktif' : 'Pasif' }}</b-badge></td>
                        <td>
                            <b-button variant="danger" size="sm" @click="deletePump(pump)">Sil</b-button>
                        </td>
                    </tr>
                    <tr v-if="pumps.length === 0">
                        <td colspan="4" class="text-center text-muted">Henüz pompa tanımlanmamış.</td>
                    </tr>
                </tbody>
            </table>
            <template #modal-footer>
                <b-button variant="secondary" @click="$hideModal('pump-management')">Kapat</b-button>
            </template>
        </b-modal>

        <v-table ref="table" :add-callback="createNew" :fields="fields" name="fuel-storage" :buttons="buttons" pagination="server" search :items-provider="provider" :editor="dataEditor" initial-sort-by="Id" :initial-sort-desc="true"> </v-table>
    </b-card>
</template>

<script>
import api from "@/api/fuel-storage";
import systemDataApi from "@/api/system-data";
import CompanyApi from "@/api/company";
import { BCard, BSpinner, BRow, BCol, BFormInput, BFormSelect, BButton, BBadge } from "bootstrap-vue";
import FuelStorageCreateOrUpdate from "./components/FuelStorageCreateOrUpdate.vue";
import FuelStorageEmployeeCreateOrUpdate from "./components/FuelStorageEmployeeCreateOrUpdate.vue";
import EmployeeOperationsApi from "@/api/employee-operations";
import FuelStorageStockBalance from "./components/FuelStorageStockBalance.vue";

export default {
    name: "FuelStorageView",
    components: { BCard, BSpinner, BRow, BCol, BFormInput, BFormSelect, BButton, BBadge, FuelStorageCreateOrUpdate, FuelStorageEmployeeCreateOrUpdate, FuelStorageStockBalance },
    data() {
        return {
            errors: {},
            editing: false,
            loading: false,
            branches: [],
            provinces: [],
            fuelTypes: [],
            integratedStorageClasses: [],
            storageClasses: [],
            fuelStorageTypes: [],
            fuelStorageMaterials: [],
            fuelStorageMobilityStatuses: [],
            FuelStorageClassId: null,
            form: {
                Id: null,
                Code: "",
                Name: "",
                FuelStorageClassId: null,
                Capacity: null,
                FuelQuantity: 0,
                FuelStorageOwningBranchId: null,
                FuelStorageFuelTypeId: null,
                IntegratedStorageClassId: null,
                FuelStorageTypeId: null,
                FuelStorageMaterialId: null,
                FuelStorageMobilityStatusId: null,
                ProvinceId: null,
                CountryId: null,
                DistrictId: null,
            },
            selectedFuelStorageId: null,
            employeeManagementLoading: false,
            allUsers: [],
            activeUsers: [],
            employeeManagementModel: {
                DataProcessorIds: [],
                OperatorIds: [],
                PurchaserIds: [],
                SupervisorIds: [],
            },
            balanceModal: {
                NewBalance: null,
                FuelStorageId: null,
            },
            selectedFuelStorage: null,
            // Pompa yönetimi
            pumpModal: { title: "Pompa Yönetimi" },
            pumpLoading: false,
            pumps: [],
            pumpForm: { Name: "", MeterType: "Dijital" },
            meterTypes: [
                { value: "Dijital", text: "Dijital" },
                { value: "Analog", text: "Analog" },
            ],
            pumpFuelStorageId: null,
            fields: [
                { name: "Kod", key: "Code", sortable: false, thClass: "w-6 text-nowrap", tdClass: "text-nowrap" },
                { name: "Ad", key: "Name", sortable: false, thClass: "w-9 text-nowrap", tdClass: "text-nowrap" },
                { name: "Depo Sınıfı", key: "FuelStorageClassName", sortable: false, thClass: "w-4 text-nowrap", tdClass: "text-nowrap" },
                { name: "Kapasite [lt]", key: "CapacityStr", sortable: false, thClass: "w-10 text-nowrap", tdClass: "text-nowrap text-right" },
                { name: "Yakıt Miktarı [lt]", key: "FuelQuantityStr", sortable: false, thClass: "w-10 text-nowrap", tdClass: "text-nowrap text-right" },
                {
                    name: "Doluluk [%]",
                    key: "FillRate",
                    sortable: false,
                    thClass: "w-16 text-nowrap",
                    tdClass: "text-nowrap",
                    component: true,
                    componentOptions: { name: "fuel-storage/StorageFillRate2" },
                },
                { name: "Şube", key: "FuelStorageOwningBranchName", sortable: false, thClass: "w-13 text-nowrap", tdClass: "text-nowrap" },
                { name: "Depo Sorumlusu", key: "supervisors", sortable: false, thClass: "w-16 text-nowrap", tdClass: "text-nowrap" },
                { name: "Veri İşlem Görevlisi", key: "dataProcessors", sortable: false, thClass: "w-16 text-nowrap", tdClass: "text-nowrap" },
            ],
            buttons: [
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.edit },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.delete },
                { text: "Çalışanları Yönet", key: "manage-employees", icon: "UsersIcon", variant: "info", action: this.openEmployeeManager },
                { text: "Stok Dengeleme", key: "balance", icon: "PercentIcon", variant: "warning", action: this.openBalanceModal },
                { text: "Pompalar", key: "pumps", icon: "SettingsIcon", variant: "dark", action: this.openPumpManager },
            ],
        };
    },
    computed: {
        hasEmployeeOverlap() {
            const { DataProcessorIds, SupervisorIds } = this.employeeManagementModel;
            if (!DataProcessorIds || !SupervisorIds || DataProcessorIds.length === 0 || SupervisorIds.length === 0) {
                return false;
            }

            const dataProcessors = new Set(DataProcessorIds);
            return false;
            // return SupervisorIds.some((id) => dataProcessors.has(id));
        },
        employeeMap() {
            const map = new Map();
            if (!this.allUsers || this.allUsers.length === 0) {
                return map;
            }

            this.allUsers.forEach((user) => {
                if (user && user.Id) {
                    map.set(user.Id.toLowerCase(), user.FullName);
                }
            });
            return map;
        },
        isSaveDisabled() {
            return !this.form.Capacity || parseFloat(this.form.Capacity) <= 0;
        },
        isEmployeeManagementSaveDisabled() {
            const model = this.employeeManagementModel;
            if (!model) return true;

            const hasDataProcessors = model.DataProcessorIds && model.DataProcessorIds.length > 0;
            const hasSupervisors = model.SupervisorIds && model.SupervisorIds.length > 0;

            return !hasDataProcessors || !hasSupervisors || this.hasEmployeeOverlap;
        },
    },
    mounted() {
        this.loadAllUsers();
        this.loadBranches();
        this.loadProvinces();
        this.loadFuelTypes();
        this.loadIntegratedStorageClasses();
        this.loadFuelStorageTypes();
        this.loadFuelStorageMaterials();
        this.loadFuelStorageMobilityStatuses();
        this.loadStorageClasses();
    },
    methods: {
        async loadAllUsers() {
            try {
                if (this.allUsers.length > 0) return;
                const response = await EmployeeOperationsApi.Employee.List(true);
                if (response.data.Success) {
                    this.allUsers = response.data.Data || [];
                    this.$refs.table.refresh();
                }
            } catch (error) {
                console.error("Tüm kullanıcılar yüklenirken hata oluştu:", error);
            }
        },
        reset() {
            this.clearForm();
            this.errors = {};
            this.selectedFuelStorageId = null;
            this.employeeManagementModel = {
                DataProcessorIds: [],
                OperatorIds: [],
                PurchaserIds: [],
                SupervisorIds: [],
            };
        },
        async loadBranches() {
            try {
                const response = await CompanyApi.Branch.ListByCode("O");
                if (response.data.Success) {
                    this.branches = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading branches:", error);
            }
        },
        async loadProvinces() {
            try {
                const response = await systemDataApi.ProvinceByCountry("43776974-AB91-4FA2-B2AC-87B5E8939241");
                if (response.data.Success) {
                    this.provinces = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading provinces:", error);
            }
        },
        async loadFuelTypes() {
            try {
                const response = await systemDataApi.FuelType(true);
                if (response.data.Success) {
                    this.fuelTypes = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading fuel types:", error);
            }
        },
        async loadIntegratedStorageClasses() {
            try {
                const response = await api.IntegratedStorageClass.List();
                if (response.data.Success) {
                    this.integratedStorageClasses = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading integrated storage classes:", error);
            }
        },
        async loadStorageClasses() {
            try {
                const response = await api.FuelStorageClass.List();
                if (response.data.Success) {
                    this.storageClasses = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading storage classes:", error);
            }
        },
        async loadFuelStorageTypes() {
            try {
                const response = await api.Data.GetFuelStorageTypeEnumList();
                if (response.data.Success) {
                    this.fuelStorageTypes = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading fuel storage types:", error);
            }
        },
        async loadFuelStorageMaterials() {
            try {
                const response = await api.Data.GetFuelStorageMaterialEnumList();
                if (response.data.Success) {
                    this.fuelStorageMaterials = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading fuel storage materials:", error);
            }
        },
        async loadFuelStorageMobilityStatuses() {
            try {
                const response = await api.Data.GetFuelStorageMobilityStatusEnumList();
                if (response.data.Success) {
                    this.fuelStorageMobilityStatuses = response.data.Data || [];
                }
            } catch (error) {
                console.error("Error loading fuel storage mobility statuses:", error);
            }
        },
        clearForm() {
            this.editing = false;
            this.form.Id = null;
            this.form.Code = null;
            this.form.Name = null;
            this.form.Capacity = null;
            this.form.FuelQuantity = null;
            this.form.FuelStorageOwningBranchId = null;
            this.form.FuelStorageFuelTypeId = null;
            this.form.IntegratedStorageClassId = null;
            this.form.FuelStorageTypeId = null;
            this.form.FuelStorageMaterialId = null;
            this.form.FuelStorageMobilityStatusId = null;
            this.form.ProvinceId = null;
            this.form.CountryId = null;
            this.form.DistrictId = null;
            this.form.FuelStorageClassId = null;
        },
        createNew() {
            this.clearForm();
            this.$showModal("create-or-update");
        },
        edit(item) {
            this.clearForm();
            this.editing = true;
            this.form.Id = item.Id;
            this.form.Code = item.Code;
            this.form.Name = item.Name;
            this.form.Capacity = item.Capacity;
            this.form.FuelQuantity = item.FuelQuantity;
            this.form.FuelStorageOwningBranchId = item.FuelStorageOwningBranchId;
            this.form.FuelStorageFuelTypeId = item.FuelStorageFuelTypeId;
            this.form.IntegratedStorageClassId = item.IntegratedStorageClassId;
            this.form.FuelStorageClassId = item.FuelStorageClassId;
            this.form.FuelStorageTypeId = item.FuelStorageTypeId;
            this.form.FuelStorageMaterialId = item.FuelStorageMaterialId;
            this.form.FuelStorageMobilityStatusId = item.FuelStorageMobilityStatusId;
            this.form.ProvinceId = item.ProvinceId;
            this.form.CountryId = item.CountryId;
            this.form.DistrictId = item.DistrictId;

            this.$nextTick(() => {
                this.$showModal("create-or-update");
            });
        },
        provider(params) {
            return api.FuelStorage.Datatable({ PaginationRequestModel: params });
        },
        createOrUpdate() {
            this.loading = true;

            const payload = {
                ...this.form,
                Capacity: parseFloat(this.form.Capacity) || 0,
                FuelQuantity: parseFloat(this.form.FuelQuantity) || 0,
            };
            api.FuelStorage.CreateOrUpdate(this.editing, payload)
                .then((res) => {
                    if (res.data.Success) {
                        this.$refs.table.refresh();
                        this.reset();
                        this.$hideModal("create-or-update");
                    }
                    this.$result(res);
                    this.loading = false;
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.loading = false;
                });
        },
        delete(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem ${item.Name} akaryakıt deposunu silecektir ve geri alınamaz.`).then((result) => {
                if (result) {
                    api.FuelStorage.Delete(item.Id)
                        .then((res) => {
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                            this.$result(res);
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        });
                }
            });
        },
        openEmployeeManager(item) {
            this.employeeManagementLoading = true;
            this.selectedFuelStorageId = item.Id;
            this.employeeManagementModel = { DataProcessorIds: [], OperatorIds: [], PurchaserIds: [], SupervisorIds: [] };
            this.activeUsers = [];
            this.$showModal("manage-employees");

            const getActiveUsersRequest = EmployeeOperationsApi.Employee.List(true);
            const getAssignedUsersRequest = api.FuelStorageEmployee.List(this.selectedFuelStorageId);

            Promise.all([getActiveUsersRequest, getAssignedUsersRequest])
                .then(([activeUsersResponse, assignedUsersResponse]) => {
                    this.activeUsers = activeUsersResponse.data.Data || [];

                    const assignedEmployees = assignedUsersResponse.data.Data || {};
                    this.employeeManagementModel.DataProcessorIds = assignedEmployees.DataProcessorIds || [];
                    this.employeeManagementModel.OperatorIds = assignedEmployees.OperatorIds || [];
                    this.employeeManagementModel.PurchaserIds = assignedEmployees.PurchaserIds || [];
                    this.employeeManagementModel.SupervisorIds = assignedEmployees.SupervisorIds || [];
                })
                .catch((err) => {
                    this.$result(null, err);
                })
                .finally(() => {
                    this.employeeManagementLoading = false;
                });
        },

        openBalanceModal(item) {
            this.errors = {};
            this.selectedFuelStorage = item;
            this.balanceModal = {
                FuelStorageId: item.Id,
                NewBalance: item.FuelQuantity,
            };
            this.$showModal("stock-balance");
        },

        async saveBalance() {
            this.errors = {};
            const newBalance = parseFloat(this.balanceModal.NewBalance);
            const capacity = parseFloat(this.selectedFuelStorage.Capacity);

            if (isNaN(newBalance)) {
                this.errors = { NewBalance: "Geçerli bir miktar giriniz." };
                return;
            }
            if (newBalance < 0) {
                this.errors = { NewBalance: "Stok miktarı 0'dan küçük olamaz." };
                return;
            }
            if (newBalance > capacity) {
                this.errors = { NewBalance: `Stok miktarı depo kapasitesini (${capacity} lt) aşamaz.` };
                return;
            }

            this.loading = true;
            try {
                const response = await api.FuelStorage.Balance(this.balanceModal);
                if (response.data.Success) {
                    this.$refs.table.refresh();
                    this.$hideModal("stock-balance");
                    this.balanceModal = { NewBalance: null, FuelStorageId: null };
                }
                this.$result(response);
            } catch (error) {
                this.$result(null, error);
            } finally {
                this.loading = false;
            }
        },

        manageEmployees() {
            this.employeeManagementLoading = true;
            const payload = {
                FuelStorageId: this.selectedFuelStorageId,
                DataProcessorIds: [...this.employeeManagementModel.DataProcessorIds],
                OperatorIds: [...this.employeeManagementModel.OperatorIds],
                PurchaserIds: [...this.employeeManagementModel.PurchaserIds],
                SupervisorIds: [...this.employeeManagementModel.SupervisorIds],
            };

            api.FuelStorageEmployee.Manage(payload)
                .then((res) => {
                    if (res.data.Success) {
                        this.$hideModal("manage-employees");
                        this.$refs.table.refresh();
                        this.reset();
                    }
                    this.$result(res);
                    this.employeeManagementLoading = false;
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.employeeManagementLoading = false;
                });
        },
        getEmployeeNames(employees) {
            if (!employees || employees.length === 0 || this.employeeMap.size === 0) {
                return "-";
            }
            const activeEmployees = employees.filter((emp) => !emp.Deleted);
            const uniqueIds = [...new Set(activeEmployees.map((emp) => emp.EmployeeId.toLowerCase()))];
            const names = uniqueIds.map((id) => this.employeeMap.get(id) || "?");
            return names.join(", ");
        },
        dataEditor(responseObject) {
            const dataPayload = responseObject.Data;
            const items = dataPayload.Data;

            if (!items || items.length === 0) {
                return dataPayload;
            }

            items.forEach((item) => {
                // DataProcessorAndSupervisors employees must appear in BOTH columns.
                // Merge them as a safety net in case the backend omits them from one list.
                const dualRoles = item.DataProcessorAndSupervisors || [];

                const supervisorList = [...(item.Supervisors || [])];
                dualRoles.forEach((e) => {
                    if (!supervisorList.some((s) => s.EmployeeId === e.EmployeeId)) supervisorList.push(e);
                });

                const dataProcessorList = [...(item.DataProcessors || [])];
                dualRoles.forEach((e) => {
                    if (!dataProcessorList.some((d) => d.EmployeeId === e.EmployeeId)) dataProcessorList.push(e);
                });

                item.supervisors = this.getEmployeeNames(supervisorList);
                item.dataProcessors = this.getEmployeeNames(dataProcessorList);
            });
            return dataPayload;
        },
        async openPumpManager(item) {
            this.pumpFuelStorageId = item.Id;
            this.pumpModal.title = `Pompa Yönetimi - ${item.Name}`;
            this.pumpForm = { Name: "", MeterType: "Dijital" };
            this.$showModal("pump-management");
            await this.loadPumps();
        },
        async loadPumps() {
            this.pumpLoading = true;
            try {
                const res = await api.FuelStoragePump.GetByStorage(this.pumpFuelStorageId);
                if (res.data.Success) {
                    this.pumps = res.data.Data || [];
                }
            } catch (error) {
                console.error("Pompalar yüklenemedi", error);
            } finally {
                this.pumpLoading = false;
            }
        },
        async addPump() {
            try {
                const res = await api.FuelStoragePump.Create({
                    FuelStorageId: this.pumpFuelStorageId,
                    Name: this.pumpForm.Name,
                    MeterType: this.pumpForm.MeterType,
                });
                if (res.data.Success) {
                    this.$toast.success(res.data.Message);
                    this.pumpForm.Name = "";
                    await this.loadPumps();
                } else {
                    this.$toast.error(res.data.Message);
                }
            } catch (error) {
                this.$toast.error("İşlem sırasında hata oluştu.");
            }
        },
        async deletePump(pump) {
            const confirmed = await this.$confirm("Silmek istediğinize emin misiniz?", `"${pump.Name}" pompası silinecektir.`);
            if (!confirmed) return;
            try {
                const res = await api.FuelStoragePump.Delete(pump.Id);
                if (res.data.Success) {
                    this.$toast.success(res.data.Message);
                    await this.loadPumps();
                } else {
                    this.$toast.error(res.data.Message);
                }
            } catch (error) {
                this.$toast.error("İşlem sırasında hata oluştu.");
            }
        },
    },
};
</script>

<style scoped></style>
